export default __webpack_public_path__ + "static/media/icon-trophy.4019dc83.svg";